import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Reveal } from '../Reveal';
import { PillButton } from '../PillButton';
import { SiblingFigure } from '../characters/SiblingFigure';
import { getSibling } from '../../data/siblings';
import type { SiblingRole } from '../../types/snak';
interface ResponseScreenProps {
  role: SiblingRole;
  onNext: () => void;
}
export function ResponseScreen({
  role,
  onNext
}: ResponseScreenProps) {
  const sibling = getSibling(role);
  const [ack, setAck] = useState<string | null>(null);
  const answer = (line: string) => {
    if (ack) return;
    setAck(line);
    window.setTimeout(onNext, 1250);
  };
  return <div className="flex flex-1 flex-col justify-center py-4" data-id="element-202" data-mp="2bznfvlgxsold">
      <Reveal data-id="element-203" data-mp="2bz3utvvzpk34">
        <div className="relative flex items-end justify-center overflow-hidden rounded-[28px] px-4 pt-6" style={{
        backgroundColor: sibling.surface
      }} data-id="element-204" data-mp="2c1q2rwmsm1lv">
          <motion.div initial={{
          y: 26,
          scale: 0.9,
          rotate: -3
        }} animate={{
          y: 0,
          scale: 1,
          rotate: 0
        }} transition={{
          type: 'spring',
          stiffness: 260,
          damping: 18,
          delay: 0.1
        }} data-id="element-205" data-mp="2l0v5zg9auj4d">
            <SiblingFigure role={role} className="h-[172px] w-auto" data-id="element-206" data-mp="1pschod14eamm" />
          </motion.div>
          <span className="absolute left-4 top-4 rounded-full bg-background px-3 py-1 font-body text-[10px] uppercase tracking-[0.18em] text-white" data-id="element-207" data-mp="1ksq5m6x130fe">
            {sibling.label}
          </span>
        </div>
      </Reveal>

      <Reveal delay={0.18} data-id="element-208" data-mp="28gpv73ilskse">
        <h2 className="mt-6 font-heading text-[30px] leading-[1.05] tracking-[-0.02em] text-background" data-id="element-209" data-mp="28hisldvo9xxv">
          {sibling.responseTitle}
        </h2>
      </Reveal>
      <Reveal delay={0.26} data-id="element-210" data-mp="1yqxxi0f7jbjp">
        <p className="mt-3 font-body text-[15px] leading-relaxed text-[rgba(1,51,43,0.72)]" data-id="element-211" data-mp="1ypmu41poc5t4">
          {sibling.responseBody}
        </p>
      </Reveal>

      <Reveal delay={0.36} className="mt-7" data-id="element-212" data-mp="2w7vbfjsghf38">
        <p className="font-heading text-[17px] text-background" data-id="element-213" data-mp="2real8dx3tpel">Sound familiar?</p>
        <div className="mt-3 flex flex-col gap-2.5" data-id="element-214" data-mp="ph9uez0122jj">
          <PillButton full onClick={() => answer('Noted. 😌')} data-id="element-215" data-mp="pjwbpqcpzwey">
            Maybe a little 😏
          </PillButton>
          <PillButton full variant="outline" onClick={() => answer('Fair enough.')} data-id="element-216" data-mp="tl7vhf8wxnf8">
            Not even close
          </PillButton>
        </div>
      </Reveal>

      <AnimatePresence data-id="element-217" data-mp="kpib99j7az3f">
        {ack && <motion.p initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0
      }} className="mt-4 text-center font-body text-[13px] text-[rgba(1,51,43,0.55)]" data-id="element-218" data-mp="5tsovaa3sjy6">
            {ack} Hold that thought.
          </motion.p>}
      </AnimatePresence>
    </div>;
}